import React, { useState } from 'react';
import './ExperimentNav.css';

interface ExperimentNavProps {
  prompt?: string;
  title?: string;
}

const ExperimentNav: React.FC<ExperimentNavProps> = ({ prompt, title }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <a href="/" className="expBackLink">← back to lab</a>

      {prompt && (
        <button
          className={`expPromptBtn ${open ? 'open' : ''}`}
          onClick={() => setOpen(true)}
          title="View prompt"
        >
          ?
        </button>
      )}

      {open && prompt && (
        <div className="expPromptOverlay" onClick={() => setOpen(false)}>
          <div className="expPromptPanel" onClick={(e) => e.stopPropagation()}>
            <div className="expPromptHeader">
              <span className="expPromptTitle">
                {title ? `PROMPT — ${title}` : 'PROMPT'}
              </span>
              <button
                className="expPromptClose"
                onClick={() => setOpen(false)}
              >
                ×
              </button>
            </div>
            <div className="expPromptBody">
              <span className="expPromptLabel">&gt; input_</span>
              <p className="expPromptText">{prompt}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExperimentNav;
